import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ToolTipIconContainer = styled.div`
  && {
    margin-left: ${spacing(2.5)};
    margin-bottom: ${spacing('sm')};
    display: flex;
    align-items: flex-start;
  }

  > div {
    display: flex !important;
  }
`;

export const $ToolTipContainer = styled.div`
  white-space: break-spaces;
  text-align: left;
`;
